import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss']
})
export class ToggleSwitchComponent implements OnInit, OnDestroy {

  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Input() checked: Boolean = false;

  subscriptions: Subscription = new Subscription();

  switchFormControl: FormControl = new FormControl(false);

  constructor() {
  }

  ngOnInit() {
    this.switchFormControl.setValue(this.checked);
    this.subscriptions.add(this.switchFormControl.valueChanges.subscribe(value => {
      this.checked = value;
      this.onChange.emit(value)
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/toggle-switch/toggle-switch.component.ts